// Special wallet IDs used throughout the UI
export const WALLET_ID_OTHER_WALLET = "otherWallet";
export const WALLET_ID_MOBILE_WALLETS = "mobileWallets";

// Connector IDs for special-case behavior
export const RABBY_CONNECTOR_ID = "io.rabby";

// Mobile wallets display rules
export const MOBILE_WALLETS_THRESHOLD_FOR_OTHER = 3; // if > 3, show "Other"
